"use strict";

const settings = {
    FACEBOOK_APP_ID: process.env.NODE_ENV === 'production' ? '486643188039729' : '704203099617069',
    GOOGLEPLACES_KEY: 'AIzaSyDjvZULdhh-W--41gR7p4QCEtxOa1kGcQ0'
};

export default settings;